/* eslint-disable react/button-has-type */
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Row, Col, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltLeft } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "components/Auth";
import { StoreContext } from "components/StoreContext";
import { CartContext } from "components/CartContext";
import CartItem from "components/CartItem";
import { CartEmptyImage } from "components/Images";
import Loading from "components/Loading";
import PriceFormat from "components/PriceFormat";
import FeaturedProducts from "components/FeaturedProducts";
import HeadTags from "components/HeadTags";
import PromotionForm from "./promos/promotionForm";
import {
  ValidPromotionFeedback,
  InvalidPromotionFeedback
} from "./promos/promotionFeedback";

const Cart = () => {
  const { authorized, signIn } = useContext(AuthContext);
  const { store } = useContext(StoreContext);
  const {
    error,
    cart,
    onCartRemove,
    onCartCheckout,
    calculateCart,
    loading,
    setCart
  } = useContext(CartContext);

  const {
    update,
    ready,
    cookie,
    items,
    count,
    subtotal,
    promotionalDiscount,
    promotionCouponCodes
    // invalidCoupon, // delete
    // appliedPromo // delete
  } = cart;
  const continueTo = sessionStorage.getItem("continue") || "/catalog";
  const [promoString, setPromoString] = useState("");
  const [previousSKUs, setPreviousSKUs] = useState([]);
  const currentSKUs = items.map(o => o.sku);

  useEffect(() => {
    const hasUpdated =
      previousSKUs.sort().toString() !== currentSKUs.sort().toString();
    if (
      store.loaded &&
      !update &&
      items.length > 0 &&
      (hasUpdated || previousSKUs.length === 0)
    ) {
      // console.log("calculating cart");
      calculateCart({ promosToApply: cart.appliedPromo });
      setPreviousSKUs(currentSKUs);
    }
    // if ( store.loaded && !update ) {
    //   console.log("previous skus:", previousSKUs.join(', '));
    //   console.log("current skus:", currentSKUs.join(', '));
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store.loaded, items]);

  if (!cookie || (cart.loaded && count === 0)) {
    return (
      <>
        <HeadTags title="Cart" />
        <section className="cart">
          <div className="cart__empty">
            <div className="cart__container">
              <div className="cart__shop">
                <Link to={continueTo}>
                  <FontAwesomeIcon icon={faLongArrowAltLeft} className="me-2" />
                  <span>Continue Shopping</span>
                </Link>
              </div>
              <div className="cart__empty-content">
                {error && <Alert color="danger">{error}</Alert>}
                <CartEmptyImage />
                <h1>Your Cart is Empty</h1>
                <p>
                  Browse our extensive catalog to find the right course for you.
                </p>
                <Link
                  to="/catalog"
                  className="btn btn-primary btn-block btn-sm"
                >
                  Browse Catalog
                </Link>
              </div>
            </div>
          </div>
          <div className="cart__container">
            <div className="cart__trending">
              <FeaturedProducts title="Trending Products" endpoint="featured" />
            </div>
          </div>
        </section>
      </>
    );
  }
  if (count > 0) {
    // console.log(cart);
    return (
      <>
        <HeadTags title="Cart" />
        <section className="cart">
          <div className="cart__container">
            <Row>
              <Col className="cart__summary" md="8">
                <div className="cart__shop">
                  <Link to={continueTo}>
                    <FontAwesomeIcon
                      icon={faLongArrowAltLeft}
                      className="me-2"
                    />
                    <span>Continue Shopping</span>
                  </Link>
                </div>
                <div className="cart__headline">
                  <h1>Your Cart:</h1>
                  <span>
                    {`${items.length} item${items.length === 1 ? "" : "s"}`}
                  </span>
                </div>
                {error && <Alert color="danger">{error}</Alert>}
                <div className="cart__items">
                  {items.map(item => (
                    <CartItem
                      key={item.sku}
                      sku={item.sku}
                      productName={item.productName}
                      author={item.author}
                      retailPrice={item.retailPrice}
                      unitPrice={item.unitPrice}
                      courseBundleCount={item.courseBundleCount}
                      omsSavedcartLineItemId={item.omsSavedcartLineItemId}
                      onCartRemove={onCartRemove}
                    />
                  ))}
                </div>
              </Col>
              <Col className="cart__order" md="4">
                <div className="checkout__loading">
                  <div className="checkout__summary">
                    <h2>Order Summary</h2>
                    <table
                      role="table"
                      className="table checkout__summary-table checkout__summary-table--cart"
                    >
                      <tbody>
                        <tr
                          role="row"
                          className="checkout__summary-table--subtotal"
                          id="cart__checkoutSummary--subtotal"
                        >
                          <td role="cell">
                            {`Item${items.length === 1 ? "" : "s"} Total (${
                              items.length
                            } Item${items.length === 1 ? "" : "s"})`}
                          </td>
                          <td role="cell">
                            <PriceFormat value={subtotal} />
                          </td>
                        </tr>
                        {promotionalDiscount > 0 && loading !== true ? (
                          <tr
                            role="row"
                            className="checkout__summary-table--promotion"
                            id="cart__checkoutSummary--promotion"
                          >
                            <td role="cell">Promotion(s)</td>
                            <td role="cell">
                              -
                              <PriceFormat value={promotionalDiscount} />
                            </td>
                          </tr>
                        ) : null}
                        <tr
                          role="row"
                          className="checkout__summary-table--taxes"
                          id="cart__checkoutSummary--taxes"
                        >
                          <td role="cell">Taxes (determined in later step)</td>
                          <td role="cell">&mdash;</td>
                        </tr>

                        <PromotionForm
                          promoString={promoString}
                          setPromoString={setPromoString}
                          calculateCart={calculateCart}
                        />

                        {promotionCouponCodes.map(promo => {
                          return promo.couponValid ? (
                            <ValidPromotionFeedback
                              setPromoString={setPromoString}
                              calculateCart={calculateCart}
                              cart={cart}
                              setCart={setCart}
                              key={promo.code}
                            />
                          ) : (
                            <InvalidPromotionFeedback
                              setPromoString={setPromoString}
                              calculateCart={calculateCart}
                              promoName={promo.code}
                              promoMessage={promo.promotionMessage}
                              key={promo.code}
                            />
                          );
                        })}

                        {loading === true && (
                          <tr role="row">
                            <td role="cell">
                              <Loading />
                            </td>
                          </tr>
                        )}
                        <tr role="row" className="promotionDivider">
                          <td role="cell">Total</td>
                          <td role="cell">
                            <PriceFormat
                              value={subtotal - promotionalDiscount}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="mt-4">
                    {authorized ? (
                      <Button
                        size="sm"
                        block
                        color="primary"
                        onClick={onCartCheckout}
                        disabled={!ready}
                      >
                        I&apos;m ready to checkout
                      </Button>
                    ) : (
                      <Button size="sm" block color="primary" onClick={signIn}>
                        Please Sign In
                      </Button>
                    )}
                  </div>
                  {!ready && cart.loading === false && <Loading />}
                </div>
              </Col>
            </Row>
          </div>
        </section>
      </>
    );
  }
  return (
    <>
      <HeadTags title="Cart" />
      <section className="cart">
        <div className="cart__loading">
          <div className="cart__loading-content">
            {error && <Alert color="danger">{error}</Alert>}
            <CartEmptyImage />
            <h1>Loading Your Cart</h1>
            <Loading bg="rgba(244,244,244,.7)" />
          </div>
        </div>
      </section>
    </>
  );
};

export default Cart;
